import { useState, useCallback } from "react";
import ConfirmDialog from "components/ConfirmDialog";

export function useConfirm() {
  const [state, setState] = useState({
    open: false,
    title: "Confirmar",
    message: "",
    resolve: null,
  });

  const confirm = useCallback(
    (message, title = "Confirmar") =>
      new Promise((resolve) => {
        setState({ open: true, title, message, resolve });
      }),
    []
  );

  const handleClose = (result) => {
    const { resolve } = state;
    setState({ open: false, title: "Confirmar", message: "", resolve: null });
    if (resolve) resolve(result);
  };

  const ConfirmModal = () => (
    <ConfirmDialog
      open={state.open}
      title={state.title}
      message={state.message}
      onConfirm={() => handleClose(true)}
      onCancel={() => handleClose(false)}
    />
  );

  return { confirm, ConfirmModal };
}
